// extracted by mini-css-extract-plugin
export default {"recipientsList":"uc6iiDOJL8OwFRMmwkFE","recipientItem":"Vh3faVYurm0Q0J3KQ1h_","btnClose":"IRDrxuT1B24VoSmNhWA6"};